import { EVENT_MANAGER_PLUGINS } from '@angular/platform-browser';
import { PreventDefaultEventPlugin } from './prevent-default-event-plugin';
import { StopEventPlugin } from './stop-event-plugin';

/** Registers {@link StopEventPlugin} and {@link PreventDefaultEventPlugin} for admin and client apps. */
export const EventModifierPluginProviders = [
    { provide: EVENT_MANAGER_PLUGINS, useClass: StopEventPlugin, multi: true },
    {
        provide: EVENT_MANAGER_PLUGINS,
        useClass: PreventDefaultEventPlugin,
        multi: true,
    },
];
